export class UpdateCloudResourceConfigurationRequestInventoryBackup {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "systemControlled",
            "baseName": "systemControlled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateCloudResourceConfigurationRequestInventoryBackup.attributeTypeMap;
    }
    constructor() {
    }
}
